import { common } from '@mui/material/colors';
import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export const SEARCH_BREAKPOINT = '@media (min-width: 1158px)';

export default makeStyles()(({ spacing, palette, breakpoints }) => ({
  content: {
    background: palette.common.white,
    padding: spacing(0, 0, 4, 0),

    [breakpoints.up('lg')]: {
      padding: spacing(4, 0, 4, 0),
    },
  },
  mainContainer: {
    display: 'grid',
    gap: spacing(4),
    gridTemplateColumns: '2fr',
    gridTemplateAreas: `"content" "sidebar"`,
    [SEARCH_BREAKPOINT]: {
      gridTemplateColumns: `${spacing(31)} auto`,
      gridTemplateAreas: '"sidebar content"',
    },
  },
  results: {
    gridArea: 'content',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
  },
  sidebar: {
    transition: 'grid-template 300ms',
    gridArea: 'sidebar',
    gridColumn: `minmax(auto-fit, ${spacing(31)})`,
    position: 'sticky',
    zIndex: 3,
    bottom: spacing(5),
    [SEARCH_BREAKPOINT]: {
      gridColumn: 'unset',
      position: 'unset',
    },
  },
  centerShowMoreTeachers: {
    marginTop: spacing(4),
    display: 'flex',
    justifyContent: 'center',
  },
  footer: {
    backgroundColor: common.white,
    padding: `${rem(30)} ${rem(0)}`,
    [breakpoints.up('lg')]: {
      padding: `${rem(120)} ${rem(90)}`,
    },
  },
}));
